import { Variants } from '@amplitude/experiment-js-client';

import { useAmplitudeExperimentBase } from '@/utils/amplitude/experiments/utils/useAmplitudeExperimentBase';

import { AmplitudeExperiments, AmplitudeVariants } from '../AmplitudeExperiments';

export const useGuideArticlesExperiment = () =>
    useAmplitudeExperimentBase(AmplitudeExperiments.GuideArticles, AmplitudeVariants.GuideArticles.Treatment);

export const hasGuideArticlesTreatment = (amplitudeExperimentFlags: Variants) =>
    amplitudeExperimentFlags[AmplitudeExperiments.GuideArticles]?.value === AmplitudeVariants.GuideArticles.Treatment;
